"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Swiper page.
 */
var SwiperPage =
/**
 * Class constructor.
 */
function SwiperPage() {
  _classCallCheck(this, SwiperPage);

  this.vertical = false; // Set to "true" if the swiper is vertical.

  this.steps = 0; // Amount of items to slide per page. Set to "0" to slide all visible items.

  this.rtl = false; // Set to "true" if the swiper is "right to left" aligned.
};

exports.default = SwiperPage;